import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../common/inputs/button';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import { intl } from '../../../locales/localesConfig';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';

const ExportPeriodSelectorPopup = props => {
  const {
    className,
    confirmTitle,
    confirmText,
    handleConfirm,
    handleCancel,
    popupState,
    confirmButtonLabel,
    cancelButtonLabel,
    loading,
    onChange,
    values,
    periodsList,
  } = props;
  if(!InterfaceTooling.popupHasToRender(popupState)) {
    return null;
  }
  return (
    <div className={
        "glass_popup glass_confirm_popup export_configuration_period_selector_popup glass_popup_" + 
        (Constants.interface.popup.types.CENTERED) + 
        (className ? " " + className : "") +
        ((popupState && popupState.show) ? " glass_popup_visible" : "")
    }>
      <label className="modal-bg" onClick={handleCancel}></label>
      <div className="modal-content export_configuration_period_selector_interface_wrapper">
        <label className="close">
          <i id="glass_popup_close_button" className="fas fa-times-circle" onClick={handleCancel}></i>
        </label>
        <header>
          <h2>{confirmTitle}</h2>
        </header>
        <article className="content">
          {confirmText}
          <Select 
            value={values["periods_criteria"]}
            onChange={onChange}
            labelLocale={intl.formatMessage({id: "exportConfigurationsAdmin.exportPeriodsCriteriaSelectorLabel" })}
            options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.periodsCriteria", "exportConfigurationsAdmin.periodsCriteriaOptions", false)}
            data-path="periods_criteria"
            className="export_configuration_periods_criteria_selector"
          />
          {(values["periods_criteria"]!="" && values["periods_criteria"]!=Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.ALL && values["periods_criteria"]!=Constants.selectKeys.exportConfigurationsAdmin.periodsCriteria.CURRENT_PERIOD) && (
            <SelectList        
              values={values["periods_selected"]}
              onChange={onChange}
              addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.addPeriodValue"/>}
              labelLocale={""}
              noMoreOptionsLocale={intl.formatMessage({ id:"exportConfigurationsAdmin.noMorePeriodsOptions" })}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(periodsList, "id", "name", true, intl.formatMessage({id: "exportConfigurationsAdmin.addPeriodValue" }))}
              valueAccesor={"id"}
              labelAccesor={"name"}
              data-path="periods_selected"
            />
          )}
        </article>
        <footer>
          {handleCancel && (
            <Button
              className="glass_confirm_popup_cancel_button"
              disabled={loading}
              onClick={handleCancel}
              labelLocale={cancelButtonLabel ? cancelButtonLabel : (<FormattedMessage id="common.dataTypes.boolean.no"/>)}
            />
          )}
          {handleConfirm && (
            <Button
              className="glass_confirm_popup_confirm_button"
              disabled={loading}
              loading={loading}
              onClick={handleConfirm}
              labelLocale={confirmButtonLabel ? confirmButtonLabel : (<FormattedMessage id="common.dataTypes.boolean.yes"/>)}
            />
          )}
        </footer>
      </div>
    </div>
  );
};

export default ExportPeriodSelectorPopup;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/exportPeriodSelectorPopup.jsx